import { adminAllEventSeen } from './admin/admin-all-event-seen';
import { adminAuth } from './admin/admin-auth';
import { adminChangeMemberStatus } from './admin/admin-change-member-status';
import { adminChangePassword } from './admin/admin-change-password';
import { adminEventSeen } from './admin/admin-event-seen';
import { adminGetMember } from './admin/admin-get-member';
import { adminGetMemberComment } from './admin/admin-get-member-comment';
import { adminLogout } from './admin/admin-logout';
import { adminResendPasswordRecoveryCode } from './admin/admin-resend-password-recovery-code';
import { adminSendPasswordRecoveryCode } from './admin/admin-send-password-recovery-code';
import { adminSetNewPassword } from './admin/admin-set-new-password';
import { adminValidationPasswordRecoveryCode } from './admin/admin-validation-password-recovery-code';
import { seriesOverview } from './admin/series-overview';
import { seriesTrashAll } from './admin/series-trash-all';
import { trashEmpty } from './admin/trash-empty';
import { trashRestore } from './admin/trash-restore';
import { trashStats } from './admin/trash-stats';
import { addCategory } from './category/add-category';
import { deleteCategory } from './category/delete-category';
import { editCategory } from './category/edit-category';
import { addComment } from './comment/add-comment';
import { getComment } from './comment/get-comment';
import { removeComment } from './comment/remove-comment';
import { removeCommentReplies } from './comment/remove-comment-replies';
import { addGCategory } from './g-category/add-g-category';
import { deleteGCategory } from './g-category/delete-g-category';
import { editGCategory } from './g-category/edit-g-category';
import { memberAllEventSeen } from './member/member-all-event-seen';
import { memberAuth } from './member/member-auth';
import { memberChangePassword } from './member/member-change-password';
import { memberEventSeen } from './member/member-event-seen';
import { memberLogout } from './member/member-logout';
import { memberRegister } from './member/member-register';
import { memberRegisterResend } from './member/member-register-resend';
import { memberRegisterVerify } from './member/member-register-verify';
import { memberRemoveComment } from './member/member-remove-comment';
import { memberResendPasswordRecoveryCode } from './member/member-resend-password-recovery-code';
import { memberSendPasswordRecoveryCode } from './member/member-send-password-recovery-code';
import { memberSetNewPassword } from './member/member-set-new-password';
import { memberUpdateProfile } from './member/member-update-profile';
import { memberValidationPasswordRecoveryCode } from './member/member-validation-password-recovery-code';
import { addPost } from './post/add-post';
import { deleteAllPost } from './post/delete-all-post';
import { deletePost } from './post/delete-post';
import { getGPosts } from './post/get-g-posts';
import { getNextPosts } from './post/get-next-posts';
import { getPost } from './post/get-post';
import { getPosts } from './post/get-posts';
import { getPreviousPosts } from './post/get-previous-posts';
import { getRelatedPosts } from './post/get-related-posts';
import { postFileUp } from './post/post-file-up';
import { postFileUpPreview } from './post/post-file-up-preview';
import { restorePost } from './post/restore-post';
import { updatePost } from './post/update-post';
import { getRobotSetting } from './setting/get-robot-setting';
import { updateContact } from './setting/update-contact';
import { updateRates } from './setting/update-rates';
import { updateRobotSetting } from './setting/update-robot-setting';
import { updateSetting } from './setting/update-setting';
import { initial } from './startup/initial';

const api = {
  initial,
  updateSetting,
  updateRates,
  updateContact,
  addCategory,
  editCategory,
  deleteCategory,
  addGCategory,
  editGCategory,
  deleteGCategory,
  deleteAllPost,
  getPreviousPosts,
  getNextPosts,
  getPost,
  addPost,
  updatePost,
  getPosts,
  getGPosts,
  deletePost,
  getRelatedPosts,
  postFileUp,
  postFileUpPreview,
  restorePost,
  comment: {
    get: getComment,
    add: addComment,
    remove: removeComment,
    removeReplies: removeCommentReplies,
  },
  admin: {
    auth: adminAuth,
    logout: adminLogout,
    changePassword: adminChangePassword,
    eventSeen: adminEventSeen,
    allEventSeen: adminAllEventSeen,
    sendPasswordRecoveryCode: adminSendPasswordRecoveryCode,
    resendPasswordRecoveryCode: adminResendPasswordRecoveryCode,
    validationPasswordRecoveryCode: adminValidationPasswordRecoveryCode,
    setNewPassword: adminSetNewPassword,
    getMember: adminGetMember,
    changeMemberStatus: adminChangeMemberStatus,
    getMemberComment: adminGetMemberComment,
    trashStats,
    trashEmpty,
    trashRestore,
    seriesOverview,
    seriesTrashAll,
    getRobotSetting,
    updateRobotSetting,
  },
  member: {
    auth: memberAuth,
    logout: memberLogout,
    changePassword: memberChangePassword,
    eventSeen: memberEventSeen,
    allEventSeen: memberAllEventSeen,
    sendPasswordRecoveryCode: memberSendPasswordRecoveryCode,
    resendPasswordRecoveryCode: memberResendPasswordRecoveryCode,
    validationPasswordRecoveryCode: memberValidationPasswordRecoveryCode,
    setNewPassword: memberSetNewPassword,
    register: memberRegister,
    registerVerify: memberRegisterVerify,
    registerResend: memberRegisterResend,
    updateProfile: memberUpdateProfile,
    removeComment: memberRemoveComment,
  },
};

export default api;
